var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tagName,{tag:"component",staticClass:"button",attrs:{"href":_vm.href,"role":_vm.role,"target":_vm.target,"data-size":_vm.size,"data-color-scheme":_vm.colorScheme}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }